import { Tooltip } from '@neo/primitives/tooltip'
import { ControlButton, useReactFlow, useStore } from '@xyflow/react'
import { Minus, Plus } from 'lucide-react'
import { useCallback } from 'react'
import { REACT_FLOW_MAX_ZOOM, REACT_FLOW_MIN_ZOOM } from 'v2/configs/constants'

const CONTROL_BUTTON_CLASS =
  '!size-7 !rounded-md !border-0 !bg-transparent !p-0 text-secondary hover:!bg-hv1 hover:text-primary focus-visible:!ring-2 focus-visible:!ring-brand focus-visible:!ring-offset-1 disabled:opacity-40'

export const ZoomInOut = () => {
  const { zoomIn, zoomOut } = useReactFlow()
  // Subscribe to zoom value for live updates
  const zoom = useStore((state) => state.transform[2])

  // Clamp zoom for disabling buttons
  const isZoomInDisabled = zoom >= REACT_FLOW_MAX_ZOOM
  const isZoomOutDisabled = zoom <= REACT_FLOW_MIN_ZOOM

  const handleZoomIn = useCallback(() => {
    if (isZoomInDisabled) return
    zoomIn({ duration: 200 })
  }, [zoomIn, isZoomInDisabled])

  const handleZoomOut = useCallback(() => {
    if (isZoomOutDisabled) return
    zoomOut({ duration: 200 })
  }, [zoomOut, isZoomOutDisabled])

  return (
    <>
      <ControlButton
        onClick={handleZoomOut}
        disabled={isZoomOutDisabled}
        data-testid="button-zoomout"
        className={CONTROL_BUTTON_CLASS}
      >
        <Tooltip content={isZoomOutDisabled ? 'Minimum zoom reached' : 'Zoom Out'}>
          <Minus className="!size-4 !fill-none" />
        </Tooltip>
      </ControlButton>

      <span
        className="mx-1 select-none font-jetbrains text-xs-400 tabular-nums text-secondary"
        data-testid="zoom-percentage"
      >
        {Math.round(zoom * 100)}%
      </span>
      <ControlButton
        onClick={handleZoomIn}
        disabled={isZoomInDisabled}
        data-testid="button-zoomin"
        className={CONTROL_BUTTON_CLASS}
      >
        <Tooltip content={isZoomInDisabled ? 'Maximum zoom reached' : 'Zoom In'}>
          <Plus className="!size-4 !fill-none" />
        </Tooltip>
      </ControlButton>
    </>
  )
}
